// extracted by mini-css-extract-plugin
export default {"container":"TooltipCVV_container__BRa4u","icone":"TooltipCVV_icone__z0hvc"};